import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    maxHeight: "calc(100% - 70px)",
  },
  dataWrapper: {
    marginLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      maxHeight: "calc(100% - 120px)",
      width: "90%",
    },
  },
}))

export default styles
